<template>
  <div class="date-picker">
    <vue-date-picker
      locale="ru-RU"
      inline
      :enable-time-picker="false"
      auto-apply
      :model-value="modelValue"
      :allowed-dates="availableDates"
      :month-change-on-scroll="false"
      @update:model-value="onUpdateModelValue"
    >
      <template #month-year="{ month, year, handleMonthYearChange }">
        <div class="date-picker__head">
          <button
            type="button"
            @click="handleMonthYearChange(false)"
          >
            <span class="date-picker__arrow prev" />
          </button>
          <span class="date-picker__head__month-year">
            {{ $options.localeData.monthNames[month] }} {{ year }}
          </span>
          <button
            type="button"
            @click="handleMonthYearChange(true)"
          >
            <span class="date-picker__arrow next" />
          </button>
        </div>
      </template>
      <template #calendar-header="{ index }">
        <div>{{ $options.localeData.daysOfWeek[index] }}</div>
      </template>
    </vue-date-picker>
  </div>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

const localeData = {
  daysOfWeek: ['ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ', 'ВС'],
  monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
  firstDay: 1,
};

const NAME_EVENT_UPDATE_MODEL_VALUE = 'update:model-value';

export default {
  name: 'DatePicker',
  components: {
    VueDatePicker
  },
  props: {
    modelValue: { default: null, type: Date },
    availableDates: { default: null, type: Array },
  },
  emits: [NAME_EVENT_UPDATE_MODEL_VALUE],
  localeData,
  methods: {
    /**
     * @description Обработать изменение даты.
     * @param {Date} value
     * @returns {void}
     */
    onUpdateModelValue(value) {
      this.$emit(NAME_EVENT_UPDATE_MODEL_VALUE, value);
    },
  }
};
</script>

<style lang="scss">
.date-picker {
  &__head {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    color: var(--action-color);
    font-size: 18px;
  }
  &__arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    margin-inline: auto;
    border-radius: 50%;
    border: 1px solid #90A0B7;
    background-position: center;
    background-repeat: no-repeat;
    transform: rotate(0);
    &:hover {
      background-color: var(--dp-hover-color);
    }
    &.next {
      background-image: url("@/assets/img/arrow-next-grey.svg");
    }
    &.prev {
      background-image: url("@/assets/img/arrow-prev-grey.svg");
    }
  }
  & .dp__main div+div {
    width: 100%;
  }
  & .dp__calendar_header_item, .dp__calendar_item {
    flex: 1;
  }
  & .dp__calendar_item {
    display: flex;
    justify-content: center;
  }
}
</style>